import {Enums} from '_app/utils';
import {appConfigService} from '_app/services';

function download(media) {
	if (media) {
		if (typeof media === 'object') {
			const Id = media.MediaID ? media.MediaID : media.ID;
			const Version = media.MediaVersion ? media.MediaVersion : media.Version;

			return appConfigService.get('serverPath') + 'MediaServe/DownloadMedia/' + Id + '/' + Version;
		}
	} else {
		return null;
	}
}

function view(media) {
	if (media) {
		if (typeof media === 'object') {
			const Id = media.MediaID ? media.MediaID : media.ID;
			const Version = media.MediaVersion ? media.MediaVersion : media.Version;

			return appConfigService.get('serverPath') + 'MediaServe/ViewMedia/' + Id + '/' + Version;
		}
	} else {
		return null;
	}
}

function go(media, excludeAnchor) {
	const anchor = excludeAnchor ? '' : '#/';
	const id = media.MediaID ? media.MediaID : media.ID;
	const version = media.MediaVersion ? media.MediaVersion : media.Version;

	if (media.Type === Enums.getType('mediaTypes').EMAIL) {
		return `${anchor}templates/${id}/templateVersions/${version}`;
	}

	return `${anchor}media/${id}/${version}`;
}

export default {
	download: download,
	view: view,
	go: go
};